var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { "margin-left": "10px" } },
      [
        _c(
          "search-item",
          {
            ref: "searchItem",
            attrs: {
              "config-module": "225600",
              "show-more-scheme": true,
              "show-simple": false,
              "expand-adv": true,
              "custom-search-items": _vm.customSearchItems
            },
            on: { advSearchItemCallBack: _vm.queryHandler }
          },
          [
            _c(
              "div",
              { attrs: { slot: "operations" }, slot: "operations" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", no: "view" },
                    on: { click: _vm.toProcess }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Handled")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", no: "edit" },
                    on: { click: _vm.toDeclare }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GoToDeclare")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "225600",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "225600",
                total: _vm.filter.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.fetchDataByPage
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }